import axios from 'axios';
/*
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import toast from 'react-hot-toast';
*/

const handleError = (err) => {
    if (err) {
        if (err?.message === 'canceled') {
            return;
        }

        let error;
        if (err.response?.data) {
            error = JSON.stringify(err.response.data, null, 4);
        } else if (err.request?.data) {
            error = JSON.stringify(err.request.data, null, 4);
        } else error = JSON.stringify(err, null, 4);
        console.error('axios error: ', error);
        /*
        toast(
            (t) => (
                <div className="text-light d-flex justify-content-between w-100">
                    {error}
                    <FontAwesomeIcon
                        size="lg"
                        className="ml-3 pop-hover"
                        icon={faTimes}
                        onClick={() => toast.dismiss(t.id)}
                    />
                </div>
            ),
            {
                duration: 7500,
                style: {
                    minWidth: '25vw',
                    background: 'red',
                },
            }
        );
        */

        throw err;
    }
};

class AxiosService {
    constructor(baseUri, authService, sessionStorageService) {
        if (!baseUri) {
            throw new Error('the base uri was not provided');
        }
        if (!authService) {
            throw new Error('the auth service was not provided');
        }

        this.baseUri = baseUri;
        this.SessionStorage = sessionStorageService;
        this.AuthorizationService = authService;

        this.AuthenticatedApi = axios.create({
            baseURL: baseUri,
            // will inject auth header on-demand later as needed.
            headers: {},
        });

        this.AuthenticatedApi.interceptors.request.use(
            async (config) => {
                await this.checkValidAuth();

                let token = await this.AuthorizationService.GetTokenSilent();

                config.headers = {
                    Authorization: `Bearer ` + token.accessToken,
                };
                return config;
            },
            async (err) => handleError(err)
        );
        this.AuthenticatedApi.interceptors.response.use(
            (response) => response,
            async (err) => handleError(err)
        );
    }

    baseUri;

    // the authenticated api
    AuthenticatedApi;

    // the authorization service
    // wrapper around MSAL
    AuthorizationService;

    SessionStorage;

    Axios() {
        return this.AuthenticatedApi;
    }

    checkValidAuth = async function () {
        let token = await this.AuthorizationService.GetTokenSilent();

        if (!token.accessToken) {
            token = await this.AuthorizationService.GetTokenPopup();
        }
    };
}

export default AxiosService;
